export default "__VITE_ASSET__DPOmxhxZ__"